import { gql } from '@apollo/client';

export default gql`
  query inspectionSubjects(
    $placeId: ID
    $page: Int
    $name: String
    $brand: String
    $model: String
    $serialNumber: String
    $search: String
    $sortBy: String
    $bucket: String
  ) {
    space {
      overInspectionSubjectsLimit
      adminRole
    }
    inspectionSubjects(
      placeId: $placeId
      page: $page
      name: $name
      brand: $brand
      model: $model
      serialNumber: $serialNumber
      search: $search
      sortBy: $sortBy
      bucket: $bucket
    ) {
      perPage
      hasNextPage
      inspectionSubjectsTotalPages
      inspectionSubjectsTotal
      inspectionSubjects {
        id
        name
        brand
        model
        serialNumber
        incomingInspectionsTotal
        overdueInspectionsTotal
        place {
          id
          name
        }
      }
    }
  }
`;
